import sessionStorage from '@postinumero/storage/sessionStorage.js';

const STATUS_KEY = 'imp_status';
const EMPLOYEE_NUMBER_KEY = 'employee_number';
export const STATUS_MANAGER = 'manager';
export const STATUS_APPLICANT = 'applicant';

const getImpersonationStatus = () => {
  const status = sessionStorage.getItem(STATUS_KEY);
  if (!status) return null;
  return status;
};

export const setUserStatus = (status) => {
  sessionStorage.setItem(STATUS_KEY, window.btoa(status));
};

export const getUserStatus = () => {
  return getImpersonationStatus()
    ? window.atob(getImpersonationStatus())
    : null;
};

export const removeUserStatus = () => {
  sessionStorage.removeItem(STATUS_KEY);
};

export const setUserEmployeeNumber = (userEmployeeNumber) => {
  sessionStorage.setItem(
    EMPLOYEE_NUMBER_KEY,
    window.btoa(JSON.stringify(userEmployeeNumber))
  );
};

export const getUserEmployeeInfo = () => {
  try {
    return JSON.parse(window.atob(sessionStorage.getItem(EMPLOYEE_NUMBER_KEY)));
  } catch (error) {
    removeUserEmployeeNumber();
    return '';
  }
};

export const removeUserEmployeeNumber = () => {
  sessionStorage.removeItem(EMPLOYEE_NUMBER_KEY);
};
